/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { string as codecString } from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { BaseCoupon } from './BaseCoupon';
const BaseCouponWithCodeParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.object([
    ['type', /* #__PURE__ */ parsers.exactly('coupon-with-code')],
    ['code', codecString],
]), BaseCoupon);
export class BaseCouponWithCode extends BaseCoupon {
    static decode(input) {
        return BaseCouponWithCodeParser.decode(input).map(res => new BaseCouponWithCode(res));
    }
    static unsafeDecode(input) {
        return BaseCouponWithCode.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return BaseCouponWithCodeParser.encode(data);
    }
    static schema() {
        return BaseCouponWithCodeParser.schema();
    }
}
